module.exports = __webpack_public_path__ + "static/media/71jA148ePCL._AC_UX569_.f532a20f.jpg";